import script from "./HomeContent3-description.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContent3-description.vue?vue&type=script&setup=true&lang=js"

import "./HomeContent3-description.vue?vue&type=style&index=0&id=357ddabe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-357ddabe"]])

export default __exports__